import { ProfileCreation } from 'views/Hiring/ProfileCreation/ProfileCreation';
import { JobBoard } from 'views/Hiring/JobBoard/JobBoard';
import { HiringResume } from 'views/Hiring/HiringResume/HiringResume';
import { NodeRouter } from 'views/Labs/NodeRouter/NodeRouter';
import { LabQuiz } from 'views/Labs/LabQuiz/LabQuiz';
import { JobInfoRouter } from 'views/Hiring/JobBoard/JobInfoRouter/JobInfoRouter';

import { TopicsSelect } from 'views/InterviewPractice/TopicsSelect/TopicsSelect';
import { InterviewProfileForm } from 'views/InterviewPractice/InterviewProfileForm/InterviewProfileForm';
import { InterviewPracticePage } from 'views/InterviewPractice/InterviewPracticePage/InterviewPracticePage';
import { InterviewResult } from 'views/InterviewPractice/InterviewResult/InterviewResult';


const Routes = [
    {
        path: '/hiring/profile',
        view: ProfileCreation,
        layout: 'app',
        permission: 'hiring.profile.view',
        title: 'Hiring Profile'
    },
    {
        path: '/hiring/jobs',
        view: JobBoard,
        layout: 'app',
        permission: 'hiring.jobs.view',
        title: 'Jobs'
    },
    {
        path: '/hiring/jobs/:job_id/:context',
        view: JobInfoRouter,
        permission: 'hiring.jobs.view',
        layout: 'app',
        title: 'Jobs'
    },
    {
        path: '/hiring/resume',
        view: HiringResume,
        permission: 'hiring.resume.view',
        layout: 'app',
        title: 'Your Resume'
    },
    {
        path: '/hiring/jobs/:job_id/assessment/:resource',
        view: NodeRouter,
        permission: 'hiring.jobs.view',
        layout: 'app',
        title: 'Live Assessment'
    },
    {
        path: '/hiring/jobs/:job_id/quiz/:context',
        view: LabQuiz,
        permission: 'hiring.jobs.view',
        layout: 'app',
        title: 'Quiz'
    },
    {
        path: '/onboarding/jobs/:job_id/:context',
        view: JobInfoRouter,
        layout: 'public',
        title: 'Job'
    },
    {
        path: '/interview/topics',
        view: TopicsSelect,
        layout: 'appPlain',
        permission: 'interview.topics.view',
        title: 'Interview Topics',
    },
    {
        path: '/interview/profile',
        view: InterviewProfileForm,
        layout: 'appPlain',
        permission: 'interview.profile.view',
        title: 'Interview Profile',
    },
    {
        path: '/interview/practice',
        view: InterviewPracticePage,
        layout: 'appPlain',
        permission: 'interview.practice.view',
        title: 'Interview Practice',
    },
    {
        path: '/interview/:sessionId/results',
        view: InterviewResult,
        layout: 'appPlain',
        permission: 'interview.results.view',
        title: 'Interview Results',
    },

]

export default Routes;
